import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileQuestion } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-[#161513] flex items-center justify-center px-4 sm:px-6 lg:px-8 relative">
      {/* Logo Background */}
      <div 
        className="absolute top-0 left-0 right-0 h-[400px] bg-cover bg-center bg-no-repeat opacity-20 z-0 pointer-events-none"
        style={{ backgroundImage: `url('/src/assets/logo.gif')` }}
      ></div>
      
      <div className="max-w-md w-full text-center relative z-10">
        <div className="w-20 h-20 bg-[#0CB4E4]/20 mx-auto flex items-center justify-center">
          <FileQuestion className="h-10 w-10 text-[#0CB4E4]" />
        </div>
        <h1 className="mt-6 text-3xl font-extrabold text-white">Page Not Found</h1>
        <p className="mt-2 text-lg text-gray-300">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="mt-6">
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 border border-[#0CB4E4]/30 shadow-md text-base font-medium rounded-xl text-white bg-[#161513] hover:bg-[#161513]/80 w-full justify-center transition-colors"
          >
            <ArrowLeft className="mr-2 h-5 w-5" />
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
